const equipmentsByPlace = {
  word1:'showing',
  word2:'of',
  word3:'equipment'
}

export default equipmentsByPlace;
